// TODO: Maybe get rid of this file as a whole and combine the reducers in their own pages?
import { combineReducers } from 'redux'
import { namedReducer as SelectedLeaguesForCloningNamedReducer } from './selected_leagues_for_cloning'
import { namedReducer as LeaguesFilterNamedReducer } from './leagues_filter_values'
import { namedReducer as CloningStepsNamedReducer } from './cloning_steps'
import { namedReducer as LeaguesConfigsNamedReducer } from './leagues_configs'
import { namedReducer as CloneLeaguesSessionStarterNamedReducer } from './clone_league_session_starter'
import { namedReducer as EnhancedLeaguesNamedReducer } from './enhanced_leagues'
import { namedReducer as PotentialLeaguesForCloningNamedReducer } from './potential_leagues_for_cloning'
import { namedReducer as CloneLeaguesSessionsNamedReducer } from './clone_leagues_sessions'
import { namedReducer as CloneLeaguesSessionsJobsPoller } from './clone_leagues_sessions_jobs_poller'
import { namedReducer as JobsFiltersReducer } from './jobs_filters'
import { namedReducer as SessionSaverReducer } from './session_saver'
import { namedReducer as LeaguesDatesReducer } from './leagues_dates'

export const newEditPageReducers = combineReducers({
  ...PotentialLeaguesForCloningNamedReducer,
  ...SelectedLeaguesForCloningNamedReducer,
  ...LeaguesFilterNamedReducer,
  ...CloningStepsNamedReducer,
  ...LeaguesConfigsNamedReducer,
  ...EnhancedLeaguesNamedReducer,
  ...CloneLeaguesSessionStarterNamedReducer,
  ...SessionSaverReducer,
  ...LeaguesDatesReducer,
})

export const indexPageReducers = combineReducers({
  ...CloneLeaguesSessionsNamedReducer,
  ...CloneLeaguesSessionsJobsPoller,
  ...JobsFiltersReducer,
})
